import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../firebase-config";
import { db } from "../../firebase-config";
import { app } from "../../firebase-config";
import { async } from '@firebase/util';
import { collection, getDocs, orderBy, addDoc, updateDoc, deleteDoc, doc, Firestore, query, where } from "firebase/firestore";
import Cookies from 'universal-cookie';
import Modal from 'react-modal';
import DatePicker from "react-datepicker";
import Moment from 'moment';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
const axios = require('axios').default;
const header = { "Access-Control-Allow-Origin": "*", 'content-type': 'application/x-www-form-urlencoded' }

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    width: '900px',
    height: '650px',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

Modal.setAppElement(document.getElementById('root'));
// export default class Login extends Component {
const PaymentsModule = (props) => {
  const cookies = new Cookies();
  const paymentsCollectionRef = collection(db, "assignedprograms");
  const [payments, setPayments] = useState([]);
  const [isLoading, setLoading] = useState(true);

  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  const exportToCSV = () => {
    var workbook = XLSX.utils.book_new();
    var worksheet_data = document.getElementById("mytable");
    var worksheet = XLSX.utils.table_to_sheet(worksheet_data);
    workbook.SheetNames.push("Test");
    workbook.Sheets["Test"] = worksheet;
    exportExcelFile(workbook);
  }
  function exportExcelFile(workbook) {
    return XLSX.writeFile(workbook, "bookName.xlsx");
  }


  const getEnvelope = async (envelopeId, id, player_id) => {
    setLoading(true);
    var body = {
      "email": props.userData.email,
      "name": props.userData.name + " " + props.userData.lastname,
      "uid": props.userData.id,
      "id": id,
      "envelopeId": envelopeId,
      "playerid": player_id,
      "clubid": props.userData.club_id
    };
    axios.post(process.env.REACT_APP_BACKEND+'getEnvelope', {
      body, header
    })
      .then(function (response) {
        console.log(response.data);
        window.open(response.data.redirectUrl, "_blank");
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  useEffect(() => {
    // cookies.set('player', "", { path: '/' });
    getPrograms();
  }, [])

  useEffect(() => {
    if (isLoading) {
      document.getElementById("data").style.display = "none";
      document.getElementById("loader").style.display = "block";
    } else {
      document.getElementById("data").style.display = "block";
      document.getElementById("loader").style.display = "none";
    }
  }, [isLoading]);

  const getPrograms = async () => {
    const q = query(paymentsCollectionRef, where("club_id", "==", props.userData.club_id), where("status", "==", "Paid"), orderBy("date_paid", "desc"));
    const data = await getDocs(q);
    setPayments(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
    setLoading(false);
  }

  var rowCounter = 0;

  return (
    <>
      <h2>Registered Payments</h2>
      <div className='row'>
        <div className='col-lg-1' style={{ display: "flex" }}>
          <button className='btn btn-primary btn-sm' style={{ marginLeft: "0px" }} onClick={() => { exportToCSV() }}>Export List</button>
        </div>
      </div>
      <div id="data" style={{ overflowX: "scroll" }}>
        <Table id="mytable" striped bordered hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Program Name</th>
              <th>Price (US Dollars)</th>
              <th>Birth Year</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Player Name</th>
              <th>Status</th>
              <th>Date Paid</th>
              <th>Doc Status</th>
            </tr>
          </thead>
          <tbody>
            {payments.map((payment) => {
              rowCounter++;
              return (
                <tr key={payment.id}>
                  <td>{rowCounter}</td>
                  <td>{payment.program_name}</td>
                  <td>${payment.price}</td>
                  <td>{Moment(payment.player_birthdate.toDate()).format('YYYY')}</td>
                  <td>{payment.startDate}</td>
                  <td>{payment.endDate}</td>
                  <td>{payment.player_name}</td>
                  <td>{payment.status}</td>
                  <td>{Moment(payment.date_paid.toDate()).format('MM/DD/YYYY')}</td>
                  <td><button className='btn btn-primary btn-sm' onClick={() => { getEnvelope(payment.envelopeId, payment.id, payment.player_id) }}>Review Documents</button></td>
                  <td>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
      <div className="loader-container" id="loader">
        <div className="loader"></div>
      </div>
    </>
  )
}

export default PaymentsModule;